import React from 'react'
import IGLogo from '../../assets/instagram-logo.png'
import TWLogo from '../../assets/twitter-logo.png'
import GHLogo from '../../assets/github-logo.png'
const Footer = () =>(
    <>
    <footer className=" bgNav2 py-3"></footer>
    <footer className=" text-white bgNav py-3">
        <div className="card-header">Contactanos</div>
        <div className="card-body ">
            <a href ="https://www.instagram.com/sm__alfredo/" rel="noreferrer" target="_blank" className="card-text text-white">
                <img src={IGLogo} className = "m-2"/>
                @sm__alfredo<br/>
            </a>
            <a href = "https://twitter.com/sm__alfredo" rel="noreferrer" target="_blank" className="card-text text-white">
                <img src={TWLogo} className = "m-2"/>
                @sm__alfredo
            </a><br/>
            <a href = "https://github.com/llFREEDll" rel="noreferrer" target="_blank" className="card-text text-white">
                <img src={GHLogo} className = "m-2"/>
                @llFREEDll
            </a>
        </div>
        <div className="card-header">Repositorio</div>
        <div className="card-body">
            <a href="https://github.com/llFREEDll?tab=repositories" rel="noreferrer" target="_blank" className="card-text text-white">
            ¡Puedes ver el código fuente de algunos de estos proyectos en GitHub!
            </a>
        </div>
            <div className="card-header">Sobre esta página</div>
            <div className="card-body">
            <p className="card-text">
            Este proyecto fue realizado para como un sitio web personal el cual tiene la finalidad de mostrar las habilidades en desarrollo web de su diseñador, también fue desarrollado como un pasatiempo en sus ratos libres, buscando matar el día, y su último propósito es recopilar todo lo aprendido en los diferentes cursos dentro de un lugar para nunca olvidar nada.<br/><br/>
                Agradecimientos especiales a:
                <br/>Duran Linares Ana Valeria<br/>García Montiel Juan Diego<br/>Uribe Baltazar Bramdon Aldair<br/>
                </p>
        </div>
    </footer>
    </>
)

export default Footer
